import React, { Children, cloneElement } from 'react';
import PropTypes from 'prop-types';
import {
  Grid,
  Typography,
  makeStyles,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@material-ui/core';

import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';

const useStyles = makeStyles((theme) => {
  return {
    root: {},
    content: {},
    item: {},
    title: {
      display: 'flex',
      justifyContent: 'center',
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
      fontWeight: 500,
      textAlign: 'center',
      fontSize: '28px',
    },
  };
});

const InputsBlock = ({
  children,
  classes: classesOverride,
  title,
  ...props
}) => {
  const classes = useStyles({ classes: classesOverride });

  return (
    <div>
      <Accordion className={classes.root}>
        <AccordionSummary
          expandIcon={<ArrowDropDownIcon />}
          aria-controls="panel1-content"
          id={`header-${title}`}
          className={classes.title}
        >
          <div
            style={{ display: 'flex', justifyContent: 'center', width: '100%' }}
          >
            {title}
          </div>
        </AccordionSummary>
        <AccordionDetails className={classes.content}>
          <Grid container className={classes.content}>
            {Children.map(children, (child) => {
              return (
                <Grid item xs={4} className={classes.item}>
                  {cloneElement(child, props)}
                </Grid>
              );
            })}
          </Grid>
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

InputsBlock.propTypes = {
  children: PropTypes.node.isRequired,
  classes: PropTypes.object,
  title: PropTypes.string.isRequired,
};

InputsBlock.defaultProps = {
  classes: {},
};

export default InputsBlock;
